import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import Seo from '../components/Seo';
import { Brush } from '../components/Brush';

export default function NoteLegali() {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    api.get('/note-legali').then((r) => setSections(r.data));
  }, []);

  return (
    <>
      <Seo
        title="Note legali"
        description="Informazioni legali sul sito VdE Tivoli 1996 e sul suo titolare, Galileo S.p.A."
        path="/note-legali"
      />

      <header className="py-14 md:py-20">
        <div className="wrap">
          <h1 className="relative inline-block">
            <span className="display-xl">Note legali</span>
            <Brush className="absolute -bottom-1 left-0 h-[0.34em] w-full" opacity={0.32} />
          </h1>
        </div>
      </header>

      <section className="py-14 md:py-20">
        <div className="wrap max-w-3xl">
          {sections.map((s) => (
            <article key={s.title} className="py-8 first:pt-0">
              <h2 className="font-display text-2xl md:text-3xl">{s.title}</h2>
              <div
                className="prosa mt-4 [&_a]:underline [&_a]:decoration-1 [&_a]:underline-offset-2 [&_li]:mt-2 [&_ul]:list-disc [&_ul]:pl-5"
                dangerouslySetInnerHTML={{ __html: s.html }}
              />
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
